import React, { useEffect, useState } from 'react';
import CustomerSupportAside from './CustomerSupportAside';
import axios from 'axios';

function DeveloperFolllowup() {
    const [schoolName, setSchoolName] = useState("");
    const [schools, setSchools] = useState([]);
    const [followups, setFollowups] = useState([]);

    const [followupDate, setFollowupDate] = useState(
        new Date().toISOString().split("T")[0]
    );

    const [issueFaced, setIssueFaced] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const Exicutive = localStorage.getItem("empName") || "";

    useEffect(() => {
        fetchSchools();
        fetchFollowups();
    }, []);

    const fetchSchools = async () => {
        try {
            const response = await axios.get("https://cleezoclass.com:8443/api/schools");
            setSchools(response.data);
        } catch (error) {
            console.error(error);
            setErrorMessage("Failed to load schools.");
        }
    };

    console.log("Schools :",schools)
    const fetchFollowups = async () => {
        try {
            const response = await axios.get(
                "https://cleezoclass.com:8443/api/customer-support/followup"
            );

            if (response.data.success) {
                setFollowups(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async () => {
        try {
            setSuccessMessage("");
            setErrorMessage("");

            if (!schoolName) {
                setErrorMessage("Please select a school.");
                return;
            }

            if (!issueFaced.trim()) {
                setErrorMessage("Please enter issue faced.");
                return;
            }

            const payload = {
                schoolName,
                followupDate,
                issueFaced,
                followupPerson: Exicutive
            };

            const response = await axios.post(
                "https://cleezoclass.com:8443/api/customer-support/followup",
                payload
            );

            if (response.data.success) {
                setSuccessMessage(response.data.message);

                setSchoolName("");
                setIssueFaced("");
                setFollowupDate(
                    new Date().toISOString().split("T")[0]
                );

                fetchFollowups();
            }
        } catch (error) {
            console.error(error);

            setErrorMessage(
                error?.response?.data?.message ||
                "Failed to save follow-up."
            );
        }

    };
    console.log("Followup",followups    )

    return (
        <div className="mainBlock">
            <h2>Customer Support Executive</h2>

            <CustomerSupportAside />

            <div className="cust-spt-conatiner">
                <h1>Follow-Up</h1>

                <div className="cust-spt-followup">

                    

         
                  

                    <h2>Followup History</h2>

                    <table
                        className="followup-history-table"
                        border="1"
                        cellPadding="10"
                        cellSpacing="0"
                        width="100%"
                    >
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>School Name</th>
                                <th>Date</th>
                                <th>Issue Faced</th>
                                <th>Followup Person</th>
                            </tr>
                        </thead>

                        <tbody>
                            {followups.length > 0 ? (
                                followups.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.school_name}</td>
                                        <td>
                                            {new Date(
                                                item.followup_date
                                            ).toLocaleDateString(
                                                "en-GB"
                                            )}
                                        </td>
                                        <td>{item.issue_faced}</td>
                                        <td>{item.followup_person}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="5"
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        No Followups Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    );
}

export default DeveloperFolllowup;